import Scenery from "../model/lover/Scenery";

import SceneryIndex from "../../lobby/view/scenery/index/SceneryIndex.vue";
import SceneryCourseVideoList from "../../lobby/view/scenery/video/SceneryCourseVideoList.vue";
import SceneryLectureVideoList from "../../lobby/view/scenery/video/SceneryLectureVideoList.vue";

let sceneryMap = {};
let sceneryList = [];

sceneryList.push(new Scenery(1, SceneryIndex, "网站首页", "该页面会出现在网站首页，主要由一篇文章，一个轮播图以及一个新闻列表组成。该页面的文章内容来自『文章』中编号为1的文章，News来自『文章』中所有新闻文章，轮播图来自『轮播图』，您可以在相应的页面中进行设置。"));

sceneryList.push(new Scenery(2, SceneryCourseVideoList, "教学视频页面", "该页面会出现在教学视频页面。"));
sceneryList.push(new Scenery(3, SceneryLectureVideoList, "其他视频页面", "该页面会出现在其他视频页面。"));


for (let i = 0; i < sceneryList.length; i++) {
	let s = sceneryList[i];
	sceneryMap[s.id] = s;
}


export {sceneryMap, sceneryList}



// WEBPACK FOOTER //
// ./src/common/store/Sceneries.js